import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { SecondaryButton } from "../../../../components/Buttons";
import ItemListManager from "../../../../components/ItemListManager";
// import TechKeyForm from './TechKeyForm';
import {
  toUIDate,
  showFile,
  TableEmptyMessage,
  CoverText,
} from "../../../../components/Utils";
import TechKeyListFormHolder from "../../containers/TechKeyListFormHolder";
import TablePageReport from "../../../../components/TablePageReport";

function TechKeyListForm(props) {
  const ref = props.forwardedRef || React.createRef();
  const disabled = React.useMemo(
    () => props.disabled || props.readOnly,
    [props.disabled, props.readOnly],
  );
  const [items, setItems] = React.useState(
    (props.model || []).map((item, index) => ({ ...item, index })),
  );
  const [first, setFirst] = React.useState(0);

  const getModel = () => {
    const model = items.map((item) => {
      return { ...item };
    });
    return model;
  };
  React.useImperativeHandle(ref, () => ({
    getModel: () => getModel(),
  }));

  const onSave = (model, onHide) => {
    // console.log('TechKeyListForm.onSanve()', model);
    if (!model) {
      return;
    }
    model.company_id = props.company.id;
    // console.log('>> saving techKey ...', model);
    if (model.index !== undefined && items[model.index] !== undefined) {
      items[model.index] = model;
    } else {
      model.index = items.length;
      items.push(model);
    }
    setItems([...items]);
    onHide && onHide();
  };

  const onDelete = (selected) => {
    // console.log('>> deleting techKey from list', selected);
    const newItems = [];
    for (const index in items) {
      // console.log('>> delete: comparing index', index, 'with selected index', selected.index);
      if (index != selected.index) {
        newItems.push(items[index]);
      }
    }
    setItems([...newItems]);
    props.onChange && props.onChange(newItems);
  };

  const { className, company, companyKeys, rows, readOnly } = props;
  const userTechKeys = items;
  const onPage = (event) => setFirst(event.first);
  const techKeys = companyKeys.filter(
    (item) => !userTechKeys.find((key) => key.name === item),
  );
  techKeys.sort();

  const fileBtnTemplate = (rowData) => {
    let btnMarkup = null;
    if (rowData.path) {
      const id = `pathBtn${rowData.index}`;
      btnMarkup = (
        <SecondaryButton
          id={id}
          size="small"
          onClick={() => showFile(rowData.path)}
        >
          {`Datei`}
        </SecondaryButton>
      );
    }
    return <div>{btnMarkup}</div>;
  };

  const renderItemTable = (items, actionTemplate) => {
    const data = items.map((item, index) => ({
      ...item,
      index,
      createdDate: toUIDate(item.created_date, "YYYY-MM-DDTHH:mm:ss:SSSZ"),
    }));
    return (
      <DataTable
        value={data}
        rows={rows}
        paginator={data.length > rows}
        first={first}
        onPage={onPage}
        paginatorLeft={
          <TablePageReport
            className="pad-lft"
            totalRecords={data.length}
            filteredRecords={data.length}
            first={first}
            rows={rows}
            emptyText="Keine Schließmittel"
            itemName="Schließmittel"
            itemNamePlural="Schließmittel"
          />
        }
        emptyMessage={<TableEmptyMessage itemNamePlural="Schließmittel" min />}
      >
        <Column
          field="number"
          header="Schließmittel"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
        />
        <Column
          field="createdDate"
          header="Datum"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          style={{ textAlign: "center", width: "10em" }}
        />
        <Column
          body={fileBtnTemplate}
          header="Übergabevereinbarung"
          style={{ textAlign: "center", width: "14em" }}
        />
        <Column
          body={actionTemplate}
          style={{ textAlign: "center", width: "7.4em" }}
        />
      </DataTable>
    );
  };

  const renderItemForm = (item, onHide) => {
    const techKey = item || {
      name: "",
      path: "",
    };
    console.log(">> editing", techKey);
    let keyList = techKeys;
    if (
      techKey.name !== "" &&
      keyList.findIndex((item) => item === techKey.name) < 0
    ) {
      keyList.push(techKey.name);
      keyList.sort();
    }
    console.log("old TechKeys:", techKeys);
    console.log("new TechKeys:", keyList);
    return (
      <TechKeyListFormHolder
        key={Math.random()}
        model={techKey}
        companyKeys={keyList /* techKeys companyKeys */}
        companyName={company.name}
        onSave={(model) => onSave(model, onHide)}
        onCancel={onHide}
        disabled={disabled}
      />
    );
  };

  const getItemFormTitle = (techKey) => {
    return (
      <h3 className="no-margin">
        {`Schließmittel ${techKey && techKey.number !== "" ? "bearbeiten" : "hinzufügen"}`}
      </h3>
    );
  };

  return (
    <ItemListManager
      key={Math.random()}
      className={className}
      title={<h3 className="no-margin-top">Technikerschlüssel</h3>}
      addBtnLabel="Hinzufügen"
      addBtnName="addWorkerTechKeyBtn"
      addBtnDisabled={readOnly}
      addBtnHidden={props.disabled}
      items={userTechKeys}
      getItemFormTitle={getItemFormTitle}
      renderItemTable={renderItemTable}
      renderItemForm={renderItemForm}
      namePrefix="techKey"
      itemVisibleOnly={disabled}
      itemDeleteable
      hideDisabledDelete
      deleteTitle="Schließmittel löschen"
      getDeleteText={(item) =>
        `Wollen Sie den Schließmittel ${item.number} unwiderruflich löschen?`
      }
      onDelete={onDelete}
    />
  );
}

TechKeyListForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.array,
  company: PropTypes.shape({}),
  companyKeys: PropTypes.array,
  rows: PropTypes.number,
};
TechKeyListForm.defaultProps = {
  className: "",
  model: [],
  rows: 5,
};

export default React.forwardRef((props, ref) => {
  return <TechKeyListForm {...props} forwardedRef={ref} />;
});


export const TechKeyListPanel = ({ className = "", model = [], rows = 10 }) => {
  const [first, setFirst] = React.useState(0);

  const onPage = (event) => {
    setFirst(event.first);
  };

  const fileBtnTemplate = (rowData) => {
    let btnMarkup = null;
    if (rowData.path) {
      const id = `pathBtn${rowData.index}`;
      btnMarkup = (
        <SecondaryButton
          id={id}
          size="small"
          onClick={() => showFile(rowData.path)}
        >
          {`Datei`}
        </SecondaryButton>
      );
    }
    return <div>{btnMarkup}</div>;
  };

  const renderItemTable = (items, actionTemplate) => {
    if (items.length === 0) {
      return (
        <CoverText>
          {"Ihnen wurden noch keine Technikerschlüssel zugewiesen"}
        </CoverText>
      );
    }
    const data = items.map((item, index) => ({
      ...item,
      index,
      createdDate: toUIDate(item.created_date, "YYYY-MM-DDTHH:mm:ss:SSSZ"),
    }));
    return (
      <DataTable
        value={data}
        rows={rows}
        paginator={data.length > rows}
        first={first}
        onPage={onPage}
        paginatorLeft={
          <TablePageReport
            className="pad-lft"
            totalRecords={data.length}
            filteredRecords={data.length}
            first={first}
            rows={rows}
            emptyText="Keine Schließmittel"
            itemName="Schließmittel"
            itemNamePlural="Schließmittel"
          />
        }
        emptyMessage={<TableEmptyMessage itemNamePlural="Schließmittel" min />}
      >
        <Column
          field="name"
          header="Schließmittel"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          body={(item) => item.name || item.productName}
        />
        <Column
          field="createdDate"
          header="erstellt am"
          sortable={data.length > 1}
          filter={data.length > rows}
          filterMatchMode="contains"
          style={{ textAlign: "center", width: "10em" }}
        />
        <Column
          body={fileBtnTemplate}
          header="Übergabevereinbarung"
          style={{ textAlign: "center", width: "14em" }}
        />
        {/* <Column
          body={actionTemplate}
          style={{textAlign:'center', width: '6em'}}
        /> */}
      </DataTable>
    );
  };

  return (
    <ItemListManager
      className={className}
      title={<h3 className="no-margin-top">Technikerschlüssel</h3>}
      addBtnHidden
      items={model}
      getItemFormTitle={() => <div />}
      renderItemTable={renderItemTable}
      renderItemForm={() => <div />}
      namePrefix="techKey"
    />
  );
};

TechKeyListPanel.propTypes = {
  className: PropTypes.string,
  model: PropTypes.array,
  rows: PropTypes.number,
};

TechKeyListPanel.defaultProps = {
  className: "",
  model: [],
  rows: 10,
};
